// Aggregates all playbook content for Mikaela. Each ability/scenario/trait
// module default-exports a typed object; this file collects them in the
// order the UI renders them.

import type { AbilityDemo, Scenario, TraitEntry, CheatRow, CombatBlock } from '@/features/playbook/types';

import loreFrance from './abilities/lore-france';
import loreParis from './abilities/lore-paris';
import artesLiberales from './abilities/artes-liberales';
import athletics from './abilities/athletics';
import awareness from './abilities/awareness';
import bargain from './abilities/bargain';
import chirurgy from './abilities/chirurgy';
import concentration from './abilities/concentration';
import etiquette from './abilities/etiquette';
import folkKen from './abilities/folk-ken';
import livingLanguage from './abilities/living-language';
import deadLanguage from './abilities/dead-language';
import magicLore from './abilities/magic-lore';
import medicine from './abilities/medicine';
import philosophiae from './abilities/philosophiae';
import profession from './abilities/profession';
import survival from './abilities/survival';

import { scenarios } from './scenarios';
import { traits } from './traits';
import { cheatRows, combatBlock } from './cheat-sheet';

export const abilityDemos: AbilityDemo[] = [
  concentration,
  etiquette,
  bargain,
  awareness,
  livingLanguage,
  deadLanguage,
  artesLiberales,
  philosophiae,
  medicine,
  chirurgy,
  loreFrance,
  loreParis,
  folkKen,
  magicLore,
  profession,
  athletics,
  survival,
];

export { scenarios, traits, cheatRows, combatBlock };
export type { AbilityDemo, Scenario, TraitEntry, CheatRow, CombatBlock };
